import { render, staticRenderFns } from "./g-select.vue?vue&type=template&id=5da651da&scoped=true"
import script from "./g-select.vue?vue&type=script&lang=js"
export * from "./g-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da651da",
  null
  
)

export default component.exports